<template>
<div>
<div>
    <div v-cloak class="mainPage">
      <header class="col-md-12">
        <Navs />
      <div class="col-md-8 col-md-offset-2 briefText">
        <h1 class="mainHeader">Who We Are </h1>
         <h3> WorkTeen is an initiative to help high school students across various Indian cities find internships, volunteering and research opportunities. </h3>
      </div>
         <md-button class="button"><md-icon>expand_more</md-icon></md-button>
      </header>

    <section class="aboutUs">

      <div class="col-md-12 text-center" style="padding-left:5%; padding-right:5%;">
            <h1 class="col-md-12 heading">
              About WorkTeen
              <hr class="col-md-6" style="margin-top:5%;">
            </h1>
            <p class="content1">
                We work with non governmental organisations, various firms and research institutes to help high school students dicover new passions and contribute towards the community.</p><p class="content1"> We are constantly on the look out for new opportunities and if you are in a position to help us expand our opportunities, we will love to talk to you. </p><p class="content1">You can leave us your contact details by messaging on our social media channels. Either way, a member of our team will get in touch with you at the earliest.
            </p>
            </div>
            <div class="col-md-6">
            </div>



      </section>
      <section class="ourTeam col-md-12">
        <h1 class="heading" >The WorkTeen Team
        <hr class="col-md-3">
        </h1>
        <div class="row">
            <div class="col-md-3 box">
            <div align="center" style="padding-bottom:2%;">
                    <md-avatar class="md-large increase2" >
                    </md-avatar>
            </div>
                <h3 class="name-heading">Kunal Mishra</h3>
                <h4>Co-founder</h4>
                <div class="row" style="margin:0 auto;">
                <div class="col-md-1 col-xs-1 col-md-offset-4">
                  <a href="https://www.facebook.com/workteen/" style="color:#427aa1"> <icon name="facebook-square" scale="2"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.facebook.com/workteen/" style="color:#427aa1"> <icon name="envelope" scale="6"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.linkedin.com/in/kunal-mishra-a2056574/" style="color:#427aa1"> <icon name="linkedin-square" scale="6"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.instagram.com/work.teen/" style="color:#427aa1"><icon name="instagram" scale="6"></icon></a>
                </div>
                </div>
            </div>

            <div class="col-md-3 box">
                <div align="center" style="padding-bottom:2%;">
                      <md-avatar class="md-large increase1">
                      </md-avatar>
                </div>
                <h3 class="name-heading">Aayush Chadha</h3>
                <h4>Co-founder</h4>
                <div class="row" style="margin:0 auto;">
                <div class="col-md-1 col-xs-1 col-md-offset-4">
                  <a href="https://www.facebook.com/workteen/" target="_blank" style="color:#427aa1"><icon name="facebook-square" scale="2"></icon></a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.facebook.com/workteen/" style="color:#427aa1"> <icon name="envelope" scale="6"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.linkedin.com/in/aayush-c-970566107/" style="color:#427aa1"> <icon name="linkedin-square" scale="6"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.instagram.com/work.teen/" style="color:#427aa1"><icon name="instagram" scale="6"></icon></a>
                </div>
                </div>
            </div>


            <div class="col-md-3 box">
                <div align="center" style="padding-bottom:2%;">
                      <md-avatar class=" md-large increase4" >
                      </md-avatar>
                </div>
                <h3 class="name-heading">Utsav Gupta</h3>
                <h4>Data Collection Team, Delhi</h4>
                <div class="row" style="margin:0 auto;">
                <div class="col-md-1 col-xs-1 col-md-offset-4">
                  <a href="https://www.facebook.com/workteen/" style="color:#427aa1"> <icon name="facebook-square" scale="2"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.facebook.com/workteen/" style="color:#427aa1"> <icon name="envelope" scale="6"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.linkedin.com/in/utsav22g/" style="color:#427aa1"> <icon name="linkedin-square" scale="6"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.instagram.com/work.teen/" style="color:#427aa1"><icon name="instagram" scale="6"></icon></a>
                </div>
                </div>
            </div>
            <div class="col-md-3 box">
                <div align="center" style="padding-bottom:2%;">
                      <md-avatar class="md-large increase5" >
                      </md-avatar>
                </div>
                <h3 class="name-heading">Anubhav Ghosh</h3>
                <h4>Front-end Developer</h4>
                <div class="row" style="margin:0 auto;">
                <div class="col-md-1 col-xs-1 col-md-offset-4">
                  <a href="https://www.facebook.com/workteen/" style="color:#427aa1"> <icon name="facebook-square" scale="2"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.facebook.com/workteen/" style="color:#427aa1"> <icon name="envelope" scale="6"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.linkedin.com/in/anubhav-ghosh-50609314b/" style="color:#427aa1"> <icon name="linkedin-square" scale="6"></icon> </a>
                </div>
                <div class="col-md-1 col-xs-1">
                  <a href="https://www.instagram.com/anubhavg8/" style="color:#427aa1"> <icon name="instagram" scale="6"></icon> </a>
                </div>
                </div>
            </div>
        </div>
  </section>


      <section class="ourWork">
      </section>





      </div>
  </div>
  <Footer />

</div>

</div>
</template>

<script>
import Footer from './Footer'

//Imports important page elements
import Navs from './Navs'

//Imports main Vue components in
import Vue from 'vue'

//Imports db constant from src/components/firebase.js
import {db} from './firebase'

//Import Footer

//Material CSS imported here
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'

import { VueTyper } from 'vue-typer'
import VueTyperPlugin from 'vue-typer'
Vue.use(VueTyperPlugin)

Vue.use(VueMaterial)

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

export default {
  name: 'AboutUs',
  components :{
    Navs,
    Icon,
    Footer
  }
};
</script>

<style scoped>
.md-chip{
  margin:3px;
  font-size: 0.6em;
}

h1{
  font-size:55px;
  text-align:center;
  font-weight: lighter;
  font-family: 'Alegreya Sans SC', sans-serif;
  /*padding:2%;*/
}
h2{
font-size:30px;
text-align:center;
font-weight: light;
font-family: 'Alegreya Sans SC', sans-serif;
/*padding:2%;*/
}
.mainPage{
  font-family: 'Lato', sans-serif;
  height:100%;
  background-color:white;
}

header{
  text-align: center;
  color:#fff;
  /*padding-top:13%;*/
  padding-bottom:13%;
  background-image: url('bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;


}

.aboutUs{
  color:#ebf2fa;
  background-color:#427aa1;
  padding-left:5%;
  padding-right:5%;
  padding-bottom:5%;
  padding-top:2%;
  line-height: 24px;

}
.box{
  margin-top:2%;
}
.ourAchievements{
  color:#ebf2fa;
  background-color:#427aa1;
  padding-left:5%;
  padding-right:5%;
  padding-bottom:5%;
  padding-top:2%;
  line-height: 24px;
  margin-top:3%;
  margin-bottom:3%;
}
.ourTeam{
  color:#427aa1;
}
.mainHeader{
  font-size:3.5em;
}

.briefText{
  padding-top:12%;
  font-size:1.3em;

}

h3{
  margin:auto;
  text-align:center;
  /*font-size:24px;*/
  line-height: 28px;
}

.button{
height: 90px;
background-color: transparent;
border: 6px solid transparent;
border-radius: 50%;
color:white;
margin:2%;
width:50px;

}

hr{
  border:2px solid #CFCFCF;
  margin-top:3%;
}

.content1{
  margin:0px;
  font-size:23px;
}
.name-heading{
  text-align: center;
  font-size: 28px;
  color:#427aa1;

}
.teamContent{
padding-left: 15%;
padding-right: 15%;
font-size: 16px;
line-height: 24px;
margin-bottom: 0px;
margin-left: 0px;
margin-right: 0px;
margin-top: 5%;
text-align: justify;
color: #427aa1;
font-family: 'Lato';
font-weight:bolder;

}
h4{
  text-align:center;
  font-size:17px;
  color:#8C8C8C;
  font-family: 'Alegreya Sans SC', sans-serif;
}

.increase1{
    width: 130px;
    min-width: 120px;
    height: 130px;
    min-height: 120px;
    border-radius: 120px;
    background-image: url('aayush.jpg');
    background-size: cover;
}
.increase2{
    width: 130px;
    min-width: 120px;
    height: 130px;
    min-height: 120px;
    border-radius: 120px;
    background-image: url('kunal.jpeg');
    background-size: cover;
}
.increase3{
    width: 130px;
    min-width: 120px;
    height: 130px;
    min-height: 120px;
    border-radius: 120px;
    background-image: url('aayush.jpg');
    background-size: cover;
}
.increase4{
    width: 130px;
    min-width: 120px;
    height: 130px;
    min-height: 120px;
    border-radius: 120px;
    background-image: url('utsav.jpg');
    background-size: cover;
}
.increase5{
    width: 130px;
    min-width: 120px;
    height: 130px;
    min-height: 120px;
    border-radius: 120px;
    background-image: url('anubhav.jpg');
    background-size: cover;
}

.socialMedia{
  color:#427aa1;
  background-color:white;
  padding-bottom:5%;
  padding-top:5%;
}
.icons{
padding:1%;
}
@media only screen and (max-width: 600px) {
  .social{
      font-size:2.4em;
  }
  .heading{
      font-size:3.0em;
  }
}
</style>



// WEBPACK FOOTER //
// AboutUs.vue?5f125b3a